import { type App, inject } from 'vue'

export type Benchmark = {
    end: (message?: string) => number
    restart(): void
}

export type BenchFunction = (prefix: string) => Benchmark

const key = 'app.plugin.bench'
export function installBench(
    app: App,
    abortController: AbortController
): BenchFunction {
    const bench = (prefix: string): Benchmark => {
        if (abortController.signal.aborted) {
            return {
                end() {
                    // eslint-disable-next-line no-console
                    console.log('Bench aborted')
                    return 0
                },
                restart() {},
            }
        }

        let startedAt = new Date()

        // eslint-disable-next-line no-console
        console.log(`${startedAt.toISOString()} > START   ${prefix}`)

        let lastDate = startedAt

        return {
            end: (message) => {
                const now = new Date()
                const total = now.getTime() - startedAt.getTime()

                if (abortController.signal.aborted) {
                    return total
                }

                const self = now.getTime() - lastDate.getTime()
                // eslint-disable-next-line no-console
                console.log(
                    `${now.toISOString()} < END     ${prefix}: total: ${total}ms, self: ${self}ms - ${message}`
                )

                lastDate = now

                return total
            },
            restart(): void {
                if (abortController.signal.aborted) {
                    return
                }

                const now = (startedAt = lastDate = new Date())
                const pausedFor = now.getTime() - startedAt.getTime()

                // eslint-disable-next-line no-console
                console.log(
                    `${startedAt.toISOString()} > RESTART ${prefix}: paused for ${pausedFor}ms`
                )
            },
        }
    }

    app.provide(key, bench)

    return bench
}

export function useBench(): BenchFunction {
    return inject(key) as BenchFunction
}
